import React from 'react';

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      title,
      titleColor,
      icon,
      bgColor,
      bgIcon,
      total,
      totalColor,
      extend,
      totalDone,
      totalInprogress
    } = this.props;

    return (
      <div className='card' style={{ backgroundColor: bgColor }}>
        <div className='card-left' style={{ backgroundColor: bgIcon }}>
          <span className={icon}></span>
        </div>
        <div className='card-right'>
          <span className='card-right__title' style={{ color: titleColor }}>{title}</span>
          <span className='card-right__total' style={{ color: totalColor }}>{total}</span>
        </div>
        {
          extend && (
            <div className='extend'>
              <span className='extend__done'>{totalDone} hoàn thành</span>
              <span className='extend__inprogress'>{totalInprogress} đang thanh tra</span>
            </div>
          )
        }
      </div>
    );
  }
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/modules/home/Card.jsx